/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import {
  Box,
  Input /* The above code is a comment in JavaScript. It is not doing anything in terms of
functionality, but it is used to provide information or explanations about the
code to other developers. */,
  Typography,
} from "@mui/material";
import { v4 as uuidV4 } from "uuid";
import Footer from "./footer";
import Dropdown from "./dropdown";
import SoftButton from "components/SoftButton";
import SoftBox from "components/SoftBox";
const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const selectStyle = {
  fontSize: "0.875rem",
  color: "#495057",
  border: "0.0625rem solid #d2d6da",
  background: "#fff",
  padding: "0.5rem 0.75rem",
  width: "100%",
  borderRadius: "0.5rem",
  outline: "none",
  minWidth: 100,
};

const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};

const partOption = [
  {
    value: "Thuế thu nhập từ tiền lương, tiền công",
    label: "Thuế thu nhập từ tiền lương, tiền công",
  },
  {
    value: "Thuế thu nhập từ hoạt động sản xuất, kinh doanh cá nhân",
    label: "Thuế thu nhập từ hoạt động sản xuất, kinh doanh cá nhân",
  },
  {
    value: "Thuế thu nhập từ vốn đầu tư vốn cá nhân",
    label: "Thuế thu nhập từ vốn đầu tư vốn cá nhân",
  },
  {
    value: "Thuế thu nhập từ chuyển nhượng vốn (không bao gồm chuyển nhượng và chứng khoáng)",
    label: "Thuế thu nhập từ chuyển nhượng vốn (không bao gồm chuyển nhượng và chứng khoáng)",
  },
  {
    value:
      "Thuế thu nhập từ chuyển nhượng bất động sản nhận thừa kế và nhận quà tặng là bất động sản",
    label:
      "Thuế thu nhập từ chuyển nhượng bất động sản nhận thừa kế và nhận quà tặng là bất động sản",
  },
];
const typePeriodOption = [
  {
    value: "Kê khai theo năm",
    label: "Kê khai theo năm  ",
  },
  {
    value: "Kê khai theo quý",
    label: "Kê khai theo quý",
  },
  {
    value: "Kê khai theo tháng",
    label: "Kê khai theo tháng",
  },
  {
    value: "Lần phát sinh",
    label: "Lần phát sinh",
  },
];

const dataTable = [
  {
    onlyTitle: true,
    bold: true,
    id: {
      value: uuidV4(),
      bg: false,
    },
    documentId: {
      type: "input",
      value: "",
      bg: false,
    },
    documentDate: {
      type: "input",
      value: "",
      bg: false,
    },
    bank: {
      type: "input",
      value: "",
      bg: false,
    },
    part: {
      type: "select",
      value: "",
      bg: true,
      option: partOption,
    },
    typePeriod: {
      type: "select",
      value: "",
      bg: false,
      option: typePeriodOption,
    },
    taxPeriod: {
      type: "input",
      value: "",
      bg: false,
    },
    amountTaxPaid: {
      type: "input",
      value: 0,
      bg: true,
    },
  },
];

export default function AppendixTable({ formData, setFieldValue }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value } = values;
    setData((prev) =>
      prev.map((item) => {
        if (item.id.value === id) {
          return { ...item, [name]: { ...item[name], value } };
        }
        return item;
      })
    );
  };

  const addNewRow = () => {
    const newRow = {
      onlyTitle: true,
      bold: true,
      id: {
        value: uuidV4(),
        bg: false,
      },
      documentId: {
        type: "input",
        value: "",
        bg: false,
      },
      documentDate: {
        type: "input",
        value: "",
        bg: false,
      },
      bank: {
        type: "input",
        value: "",
        bg: false,
      },
      part: {
        type: "select",
        value: "",
        bg: true,
        option: partOption,
      },
      typePeriod: {
        type: "select",
        value: "",
        bg: false,
        option: typePeriodOption,
      },
      taxPeriod: {
        type: "input",
        value: "",
        bg: false,
      },
      amountTaxPaid: {
        type: "input",
        value: 0,
        bg: true,
      },
    };
    setData((prev) => [...prev, newRow]);
  };

  const removeRow = () => {
    if (data.length !== 1) {
      data.pop();
      const newRow = data;
      setData([...newRow]);
    }
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box>
        <table style={tableStyle}>
          <thead>
            <tr>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                STT
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Số chứng từ
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Ngày chứng từ
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Ngân hàng/Kho bạc nhà nước nơi nộp thuế
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", width: "20%" }}>
                Tiểu mục
              </Td>
              <Td colSpan={2} style={{ textAlign: "center", width: "20%" }}>
                Kỳ thuế (nếu có)
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Số thuế đã nộp
              </Td>
            </tr>
            <tr>
              <Td rowSpan={1} style={{ textAlign: "center", width: "10%" }}>
                Loại kỳ
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Kỳ thuế
              </Td>
            </tr>
            <tr>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (1)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (2)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (3)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (4)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (5)
              </Td>
              <Td colSpan={2} style={{ textAlign: "center" }}>
                (6)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (7)
              </Td>
            </tr>
          </thead>
          <tbody>
            {data &&
              data.length > 0 &&
              data.map((row, index) => (
                <tr key={row.id.value}>
                  <Td
                    row={""}
                    style={{
                      textAlign: "center",
                      background: "transparent",
                    }}
                  >
                    {index + 1}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "center",
                      background: !row.documentId.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.documentId?.type !== "input" ? (
                      row.documentId.value
                    ) : (
                      <InputTable
                        type={"text"}
                        id={row.id.value}
                        name="documentId"
                        value={row.documentId.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "center",
                      background: !row.documentDate.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.documentDate?.type !== "input" ? (
                      row.documentDate.value
                    ) : (
                      <InputTable
                        type={"text"}
                        id={row.id.value}
                        name="documentDate"
                        value={row.documentDate.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>
                  <Td
                    row={row}
                    style={{
                      textAlign: "center",
                      background: !row.bank.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.bank?.type !== "input" ? (
                      row.bank.value
                    ) : (
                      <InputTable
                        type={"text"}
                        id={row.id.value}
                        name="bank"
                        value={row.bank.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "center",
                      background: !row.part.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.part?.type !== "select" ? (
                      row.part.value
                    ) : (
                      <SelectTable
                        name="part"
                        id={row.id.value}
                        option={row.part.option ? row.part.option : defaultOption}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "center",
                      background: !row.typePeriod.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.typePeriod?.type !== "select" ? (
                      row.typePeriod.value
                    ) : (
                      <SelectTable
                        name="typePeriod"
                        id={row.id.value}
                        option={row.typePeriod.option ? row.typePeriod.option : defaultOption}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "center",
                      background: !row.taxPeriod.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.taxPeriod?.type !== "input" ? (
                      row.taxPeriod.value
                    ) : (
                      <InputTable
                        type={"text"}
                        id={row.id.value}
                        name="taxPeriod"
                        value={row.taxPeriod.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>
                  <Td
                    row={row}
                    style={{
                      textAlign: "center",
                      background: !row.amountTaxPaid.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.amountTaxPaid?.type !== "input" ? (
                      row.amountTaxPaid.value
                    ) : (
                      <InputTable
                        type={"text"}
                        id={row.id.value}
                        name="amountTaxPaid"
                        value={row.amountTaxPaid.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>
                </tr>
              ))}

            <tr>
              <Td
                colspan="6"
                row={{ bold: true }}
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              >
                Tổng cộng:
              </Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                0
              </Td>
            </tr>
          </tbody>
        </table>
        <SoftBox display="flex" justifyContent="flex-start" gap={3} mt={2}>
          <SoftButton variant="gradient" color="dark" onClick={addNewRow}>
            Thêm dòng
          </SoftButton>
          <SoftButton variant="gradient" color="light" onClick={removeRow}>
            Xóa dòng
          </SoftButton>
        </SoftBox>
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { id, onChange, type, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;
  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value;
    if (type == "number") {
      if (!regexNumber.test(newValue)) return;
      onChange({ id, value: newValue !== "" ? +newValue : "", name });
    } else if (type == "decimal") {
      if (!regexDecimal.test(newValue)) return;
      onChange({ id, value: newValue, name });
    } else {
      onChange({ id, value: newValue !== "" ? newValue : "", name });
    }
  }
  return (
    <input
      type="text"
      style={{
        textAlign: type === "number" ? "right" : "left",
        fontSize: 16,
        color: "#344767",
        border: "none",
        background: "transparent",
        padding: "4px 4px 4px 4px",
        width: "100%",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
function SelectTable(props) {
  const { id, onSelect, type, option, name, style, ...rest } = props;
  const [newValue, setNewValue] = useState();
  useEffect(() => {
    if (typeof onSelect === "function") {
      onSelect({ id, value: newValue !== "" ? newValue : "", name, type, rowType });
    }
  }, [newValue]);
  return (
    <div style={style}>
      <Dropdown option={option} id={id} newValue={newValue} setNewValue={setNewValue} />
    </div>
  );
}
